class WonderoralProduct extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-wo-thumb]').forEach((button) => {
      button.addEventListener('click', () => this.showMedia(button.dataset.woThumb));
    });
    const select = this.querySelector('[data-wo-variant-select]');
    if (select) select.addEventListener('change', () => this.changeVariant(select));
  }

  showMedia(id) {
    this.querySelectorAll('[data-wo-media]').forEach((media) => media.classList.toggle('is-active', media.dataset.woMedia === id));
    this.querySelectorAll('[data-wo-thumb]').forEach((thumb) => {
      const active = thumb.dataset.woThumb === id;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  changeVariant(select) {
    const option = select.selectedOptions[0];
    const id = option.value;
    const available = option.dataset.available === 'true';
    const formId = select.dataset.formId;
    const input = this.querySelector(`#${CSS.escape(formId)} input[name="id"]`);
    if (input) input.value = id;
    const price = this.querySelector('[data-wo-price]');
    if (price) price.textContent = option.dataset.price;
    const compare = this.querySelector('[data-wo-compare]');
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    const button = this.querySelector(`#${CSS.escape(formId)} button[type="submit"]`);
    if (button) {
      button.disabled = !available;
      button.querySelector('span').textContent = available ? button.dataset.availableText : button.dataset.soldText;
    }
    if (option.dataset.mediaId) this.showMedia(option.dataset.mediaId);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', id);
    window.history.replaceState({}, '', url);
  }

}
if (!customElements.get('wonderoral-product')) customElements.define('wonderoral-product', WonderoralProduct);
